import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        // Track virtual page view for GA4 on every route change
        trackPageView(pathname);
    }, [pathname]);

    return null;
};

export default ScrollToTop;
